import React from "react";
import Image from "next/image";
import { putCommasIntoNumber, roundTo } from "@ecologi/shared";
import styles from "../styles/EquivalentCard.module.scss";

export type TypeKey = "car" | "flights" | "ice";

const tonneEquivalentMiles = 2547; // miles per tonne
const tonneEquivalentKM = tonneEquivalentMiles * 1.60934;
const tonneEquivalentFlights = 1.30323; // 1.3 tonnes
const tonneEquivalentIce = 3; // 3 square metres

type Props = {
  isShowKMs?: boolean;
  typeKey: TypeKey;
  setInfoPopupTypeKey: (key: TypeKey | null) => void;
  tonnesOfCO2: number;
};

export const EquivalentCard: React.FC<Props> = (props) => {
  const { typeKey, isShowKMs, setInfoPopupTypeKey, tonnesOfCO2 } = props;

  const isLongHaulFlights = typeKey === "flights";
  const isIceSaved = typeKey === "ice";

  let number = Math.round(
    tonnesOfCO2 * (isShowKMs ? tonneEquivalentKM : tonneEquivalentMiles)
  );
  let text = `${isShowKMs ? "kilometers" : "miles"} driven in a car` as any;

  if (isLongHaulFlights) {
    number = roundTo(0)(tonnesOfCO2 / tonneEquivalentFlights);
    text = `long haul flight${number === 1 ? "" : "s"}`;
  } else if (isIceSaved) {
    number = roundTo(0)(tonnesOfCO2 * tonneEquivalentIce);
    text = (
      <span>
        metre{number === 1 ? "" : "s"}
        <sup>2</sup> of sea ice saved
      </span>
    );
  }

  const bgImage = isLongHaulFlights
    ? "plane.png"
    : isIceSaved
    ? "ice.png"
    : "cars.png";

  return (
    <li className={styles.equivalentCard} data-testid="carbon-equivalent-card">
      <Image
        className={styles.bgImage}
        src={`/images/app/equivalents/${bgImage}`}
        alt=""
        layout="responsive"
        width={788}
        height={988}
      />
      <div className={styles.equivalentCardCopy}>
        <p className={styles.equivalentCardAmount}>
          {putCommasIntoNumber(number)}
        </p>
        <h4 className={styles.equivalentCardTitle}>{text}</h4>
        <button
          aria-label="more info"
          className={styles.infoButton}
          onClick={(e) => {
            e.preventDefault();
            e.currentTarget.blur();
            setInfoPopupTypeKey(typeKey);
          }}
        />
      </div>
    </li>
  );
};
